export default {
  "content": "<path d=\"M13.043 2.737c1.438 0 2.673.417 3.661 1.247.974.82 1.63 1.976 2.045 3.328l-1.912.587c-.34-1.105-.825-1.883-1.42-2.383-.581-.49-1.343-.779-2.374-.779-1.152 0-2.275.464-3.134 1.547-.511.646-.948 1.542-1.224 2.74h5.593v2H8.403a16.505 16.505 0 00-.007 1.894h5.063v2H8.641c.264 1.275.702 2.217 1.224 2.887.836 1.071 1.952 1.54 3.178 1.54 1.032 0 1.793-.289 2.374-.778.595-.5 1.08-1.278 1.42-2.383l1.912.587c-.416 1.352-1.07 2.508-2.044 3.327-.988.83-2.224 1.248-3.662 1.248-1.791 0-3.51-.715-4.755-2.31-.81-1.04-1.385-2.41-1.683-4.118H4.5v-2h1.895a18.573 18.573 0 01.008-1.894H4.5v-2h2.14c.317-1.648.902-2.973 1.702-3.982 1.255-1.584 2.967-2.305 4.701-2.305z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};